module.exports = __webpack_public_path__ + "img/239.00df2c0.svg";